import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceGeneralSettingsPage } from '../../components/settings/settings-shell.js';

export const Route = createFileRoute('/settings/general')({
  component: WorkspaceGeneralSettingsPage,
});
